import { brand } from '../../theme/themePrimitives';
import CardWrapper from '../../components/wrapper/card';
import { PlanObject } from '../../params/redux/subscription';
import { styled } from '@mui/material/styles';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, Switch, Typography } from '@mui/material';
import { checkoutPlanThunk, fetchCurrentPlanDetailsThunk, getPlansThunk } from '../../redux/thunks/subscription';
import { Close, Done } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const IOSSwitch = styled(Switch)(({ theme }) => ({
    'width': 42,
    'height': 26,
    'padding': 0,
    '& .MuiSwitch-switchBase': {
        'padding': 0,
        'margin': 2,
        'transitionDuration': '370ms',
        '&.Mui-checked': {
            'transform': 'translateX(16px)',
            'color': '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: brand[300],
                opacity: 1,
                border: 0
            }
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5
        }
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500
        })
    }
}));

const SubscriptionPage = () => {
    const dispatch = useDispatch<AppDispatch>();
    // const navigate = useNavigate();
    const [isAnnual, setIsAnnual] = useState<boolean>(false);
    const { plans, subscription, loaders } = useSelector((state: RootState) => state.subscription);
    const { currentUser } = useSelector((state: RootState) => state.app);

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                await dispatch(getPlansThunk()).unwrap();
                await dispatch(fetchCurrentPlanDetailsThunk()).unwrap();
            } catch (e) {
                //
            }
        };
        fetchPlans();
    }, []);

    const subscribePlanHandler = async (plan_id: number) => {
        try {
            const response: { url?: string } = await dispatch(checkoutPlanThunk(plan_id)).unwrap() as { url?: string };
            if (response && typeof response.url === 'string') {
                window.location.href = response.url;
            }
        } catch (e) {
            //
        }
    };

    const selectPlanHandler = (plan: PlanObject) => {
        // if (subscription) {
        //     try {
        //         await dispatch(fetchProratedChargeThunk(plan.id || 0)).unwrap();
        //         dispatch(settingSelectedPlan(plan));
        //         dispatch(settingSelectedTabForCompany(2));
        //         navigate('/app/company-management');
        //     } catch (e) {
        //         // Catch errors
        //     }
        // } else {
            subscribePlanHandler(plan.id);
        // }
    };

    return (
        <Box py={4} overflow="auto">
            {loaders.isLoading
                ? <Box display="flex" flexDirection="column" gap={2} justifyContent="center" alignItems="center">
                    <CircularProgress />
                    <Typography>Loading...</Typography>
                </Box>
                : <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
                    {/* {subscription && <Box display="flex" justifyContent="start" width="100%">
                        <Button startIcon={<KeyboardArrowLeft />} variant="text" color="secondary" onClick={() => navigate('/app/company-management')}>Go Back</Button>
                    </Box>} */}
                    <Typography variant="h3" fontWeight="600">Pricing Plans</Typography>
                    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mb={currentUser?.billing_enabled ? 1 : 0}>
                        <Typography variant="subtitle1" mb={1} color="textSecondary">Choose the best plan to fit your needs</Typography>
                        <Box display="flex" alignItems="center" gap={2}>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                sx={{ fontWeight: isAnnual ? 'normal' : 'bold' }}
                            >
                                Monthly
                            </Typography>

                            {/* Toggle Switch */}
                            <IOSSwitch
                                checked={isAnnual}
                                onChange={() => setIsAnnual(!isAnnual)}
                            />

                            {/* Annual Label */}
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                sx={{ fontWeight: isAnnual ? 'bold' : 'normal' }}
                            >
                                Annual
                            </Typography>
                        </Box></Box>
                    {!currentUser?.billing_enabled && <Box width="100%" bgcolor="#e0f7fa" display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={1.5}>
                        <Typography variant="subtitle1" align="center" fontWeight="bold" color="#218777">🎉 Start your {currentUser?.special_link ? '37-Day' : '14-Day'} free trial</Typography>
                        {/* {currentUser?.special_link && <Typography variant="subtitle1" align="center" color={red[300]}>OCA Special: Get 50% off on yearly plans</Typography>} */}
                    </Box>}
                    <Box display="flex" gap={4} justifyContent="center" mt={2}>
                        {
                            plans.filter((item) => (isAnnual ? item.product_type === 'Yearly' : item.product_type === 'Monthly'))
                                .map((plan) => <CardWrapper
                                    key={plan.id}
                                    sx={{
                                        position: 'relative',
                                        minWidth: '25vw',
                                        boxShadow: '0 4px 37px rgba(0, 0, 0, 0.06)',
                                        p: 4,
                                        pt: 5,
                                        border: 'none',
                                        borderRadius: 2
                                    }}
                                >
                                    {!currentUser?.billing_enabled && <Box position="absolute" top="-10px" right="-10px" display="flex" justifyContent="center" alignItems="center" mb={1}>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                backgroundColor: '#4caf50',
                                                color: 'white',
                                                px: 1.5,
                                                py: 0.5,
                                                borderRadius: '999px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {currentUser?.special_link ? '37-Day' : '14-Day'} Trial
                                        </Typography>
                                    </Box>}
                                    {subscription?.plan?.id === plan.id && <Box position="absolute" top="-10px" right="-10px" display="flex" justifyContent="center" alignItems="center" mb={1}>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                backgroundColor: '#4caf50',
                                                color: 'white',
                                                px: 1.5,
                                                py: 0.5,
                                                borderRadius: '999px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Active
                                        </Typography>
                                    </Box>}
                                    <Box>
                                        {/* <Box display="flex" flexDirection="column" gap={1} alignItems="center" >
                                                <img
                                                    src={plan.product_name === 'Growth' ? ImageClass.growthImage : ImageClass.starterImage}
                                                    alt={plan.product_name === 'Growth' ? 'Growth Plan' : 'Starter Plan'}
                                                />
                                            </Box> */}
                                        <Typography variant="h4" lineHeight="1">{plan.product_name}</Typography>
                                        <Typography variant="subtitle1" color="textSecondary">{plan.product_description}</Typography>
                                        <Typography variant="h2" fontWeight="600" color="#3f51b5" mt={2} mb={3}>${plan.product_price}  <Typography component="span" variant="subtitle1" fontWeight="600" color="textSecondary">/{isAnnual ? 'year' : 'month'}</Typography></Typography>
                                        <Box display="flex" flexDirection="column" my={2} mb={4} gap={'5px'}>
                                            {
                                                plan.plan_bullets.map((bullet) => <Box key={bullet.id} display="flex" alignItems="center" gap={1}>
                                                    {bullet.allowed === 1 ? <Done /> : <Close />}
                                                    <Typography variant="body2" fontSize="1rem">{bullet.description}</Typography>
                                                </Box>)
                                            }
                                        </Box>
                                        <Button
                                            variant="contained"
                                            color={subscription && subscription?.plan ? (subscription?.plan.id === plan.id ? 'secondary' : 'primary') : 'primary'}
                                            onClick={() => selectPlanHandler(plan)}
                                            sx={{
                                                bgcolor: '#3f51b5'
                                            }}
                                            fullWidth
                                            disabled={subscription && subscription?.plan ? subscription?.plan.id === plan.id : false}
                                        >
                                            {subscription && subscription?.plan && subscription?.plan.id === plan.id ? 'Current Plan' : !currentUser?.billing_enabled && currentUser?.special_link ? 'Start 37-Day Trial' : !currentUser?.billing_enabled && !currentUser?.special_link ? 'Start 14-Day Trial' : 'Select Plan'}
                                        </Button>
                                    </Box>
                                </CardWrapper>)
                        }
                    </Box>
                    <Typography variant="body2" color="textDisabled" align="center">Note: subscriptions are prorated. if you choose to upgrade or downgrade your plan - we will apply the $ you already spent and haven&apos;t used to your new subscription plan</Typography>
                </Box>}
        </Box>
    );
};

export default SubscriptionPage;